import {useParams, useSearchParams} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import {Tabs, TabsContent, TabsList, TabsTrigger} from '@/components/ui/tabs'
import {PageHeading} from '@/components/page-heading'
import {MiSoportesBody} from '@/pages/empresa/mi_espacio/mi-soportes'
import {MiSolicitudesBody} from '@/pages/sgsst/evidencias/mi-solicitudes'

type TabKey = 'soportes' | 'solicitudes'

function parseTab(value: string | null): TabKey | null {
  return value === 'soportes' || value === 'solicitudes' ? value : null
}

export function MiSoportesSolicitudesPage() {
  const {t} = useTranslation()
  const {businessId} = useParams()
  const [searchParams, setSearchParams] = useSearchParams()

  const tab = parseTab(searchParams.get('tab')) ?? 'soportes'
  function setTab(next: TabKey) {
    setSearchParams(
      (prev) => {
        const params = new URLSearchParams(prev)
        params.set('tab', next)
        return params
      },
      {replace: true}
    )
  }

  return (
    <div className="space-y-5">
      <PageHeading title={t('miSoportesSolicitudes.title')} subtitle={t('miSoportesSolicitudes.subtitle')} />

      <Tabs value={tab} onValueChange={(v) => setTab(v as TabKey)}>
        <TabsList className="[&>button]:shrink-0">
          <TabsTrigger value="soportes" data-testid="tab-soportes">
            {t('miSoportesSolicitudes.tabs.soportes')}
          </TabsTrigger>
          <TabsTrigger value="solicitudes" data-testid="tab-solicitudes">
            {t('miSoportesSolicitudes.tabs.solicitudes')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="soportes" className="pt-4">
          <MiSoportesBody businessId={businessId} />
        </TabsContent>
        <TabsContent value="solicitudes" className="pt-4">
          <MiSolicitudesBody businessId={businessId} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
